import React from 'react'
import { AlertCircleIcon } from 'src/editor/shared/icons/alert-circle-icon'
import {
  DialogWindow,
  DialogWindowIconThemeEnum,
  DialogWindowProps,
} from './dialog-window'

export interface WarningDialogWindowProps
  extends Omit<DialogWindowProps, 'icon' | 'iconTheme'> {}

export const WarningDialogWindow = (props: WarningDialogWindowProps) => {
  return (
    <DialogWindow
      icon={<AlertCircleIcon />}
      iconTheme={DialogWindowIconThemeEnum.Warning}
      {...props}
    />
  )
}
